export interface ChangelogSection {
  title: string;
  items: string[];
}

export interface ChangelogEntry {
  version: string;
  date: string;
  sections: ChangelogSection[];
}

const VERSION_HEADING = /^##\s+v?(\d+\.\d+\.\d+(?:[-+][0-9A-Za-z.-]+)?)\s*(?:—|-)\s*(\d{4}-\d{2}-\d{2})\s*$/;
const SECTION_HEADING = /^###\s+(.+?)\s*$/;
const BULLET = /^[-*]\s+(.+?)\s*$/;

/**
 * The changelog modal is built from `CHANGELOG.md` itself — never a second,
 * hand-written copy (project-start-standards §1).
 */
export function parseChangelog(markdown: string): ChangelogEntry[] {
  const lines = markdown.split(/\r?\n/);
  const entries: ChangelogEntry[] = [];
  let entry: ChangelogEntry | null = null;
  let section: ChangelogSection | null = null;

  for (const line of lines) {
    const versionMatch = VERSION_HEADING.exec(line);
    if (versionMatch) {
      entry = { version: versionMatch[1], date: versionMatch[2], sections: [] };
      entries.push(entry);
      section = null;
      continue;
    }
    if (!entry) {
      continue;
    }
    const sectionMatch = SECTION_HEADING.exec(line);
    if (sectionMatch) {
      section = { title: sectionMatch[1], items: [] };
      entry.sections.push(section);
      continue;
    }
    const bulletMatch = BULLET.exec(line);
    if (bulletMatch && section) {
      section.items.push(bulletMatch[1]);
    }
  }

  if (entries.length === 0) {
    throw new Error('CHANGELOG.md has no "## v<semver> — <date>" sections');
  }
  return entries;
}
